import { Grid } from '@mui/material'
import { observer } from 'mobx-react-lite'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import history from '../../history'
import { useStore } from '../../Provider'
import { scrollHelper, scrollSaver } from '../common/scrollHelper'
import { Toast } from '../OPcomponents/Toast'
import { OPLoadingCircle } from './OPLoadingcircle'
import { OPLoadMore } from './OPLoadMore'
import { Data, OPNewTable } from './OPNewTable'
import OPSearch from './OPSearch'

export const HrPage = observer((): JSX.Element => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const rootStore = useStore()
  const [tableLength, setTableLength] = useState(10)

  const { isHr } = rootStore.loginStore
  const { scrollPosition, stepperAmount } = rootStore.seachStore
  const { getHrDiscussionsV2, filteredEmployees, setSearchValue, searchValue, loadingInitial } = rootStore.managerStore

  const onRowClick = (id: number | string) => {
    scrollSaver(tableLength, rootStore)
    history.push(`/hr/development/${id}`, 'hrPage')
  }

  useEffect(() => {
    if (scrollPosition) {
      setTimeout(() => window.scrollTo(0, scrollPosition), 100)
    }
  }, [])

  const [tableRows, setTableRows] = useState<Data[]>([])

  useEffect(() => {
    const rows: Data[] = []
    filteredEmployees.forEach((employee) => {
      rows.push({
        ['id']: employee.personId.toString(),
        rows: {
          [t('Discussions.DiscussionEmployee')]: { text: employee.personName },
          [t('Discussions.DiscussionEmployer')]: { text: employee.managerName },
          [t('Discussions.LatestKeke')]: {
            text: employee.latestCompleteDiscussionTime ? moment(employee.latestCompleteDiscussionTime).locale(language).format('L') : '',
          },
          [t('Discussions.LatestMiniKeke')]: {
            text: employee.latestMiniDiscussionTime ? moment(employee.latestMiniDiscussionTime).locale(language).format('L') : '',
          },
          [t('Discussions.LatestGoal')]: {
            text:
              employee.goalsToComplete !== null && employee.goalsToComplete.length > 0
                ? moment(employee.goalsToComplete[0].created).locale(language).format('L')
                : '',
          },
          [t('Discussions.NewestKekeDate')]: {
            text: employee.latestOpenDiscussionTime ? moment(employee.latestOpenDiscussionTime).locale(language).format('L') : '',
          },
          [t('Discussions.NewestKekeState')]: {
            text:
              employee.latestOpenDiscussionState !== undefined
                ? t(`DiscussionsStates.${employee.latestOpenDiscussionState}`)
                : t('Discussions.'),
          },
        },
      })
    })
    setTableRows(rows)
  }, [filteredEmployees, language, t])

  useEffect(() => {
    return () => {
      scrollHelper('/hr/development/:userId', setSearchValue, false, rootStore)
    }
  }, [])

  useEffect(() => {
    if (isHr && filteredEmployees.length === 0) getHrDiscussionsV2()
  }, [filteredEmployees.length, getHrDiscussionsV2, isHr, setSearchValue])

  return (
    <Grid container spacing={4}>
      <Toast />
      <Grid item xs={12} marginBottom={'-1rem'}>
        <p className='profile--titlebigfont'>{t('Discussions.NavHR')}</p>
      </Grid>
      <Grid item xs={12}>
        <Grid container direction='row' justifyContent='space-between' alignItems='center'>
          <OPSearch
            placeholder={t('Discussions.FindPerson')}
            searchValue={searchValue}
            onSearchChange={(value) => setSearchValue(value)}
            resetValue={() => setSearchValue('')}
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        {loadingInitial ? (
          <OPLoadingCircle />
        ) : filteredEmployees.length ? (
          <>
            <OPNewTable rows={tableRows} curLength={tableLength} onRowClick={onRowClick} />
            <OPLoadMore
              startingStepper={stepperAmount}
              stepper={10}
              filteredArray={filteredEmployees}
              curLength={tableLength}
              maxLength={filteredEmployees.length}
              onLoadMore={(data) => setTableLength(data)}
            />
          </>
        ) : (
          <span className='profile--notfound'>{t('NotFound.NoResults')}</span>
        )}
      </Grid>
    </Grid>
  )
})
